/* ------------------------------------------------------------------
   Mr. Football - "Find my size" calculator, shown inside the product
   page size-chart popup.

   BUG FIX HISTORY ("clicks me off" while typing height/weight):
   v1-v5: see prior deploys. Captured a real failure via an on-page
   debug log (append &mfdebug=1 to the URL). The log showed the exact
   moment of failure: pointerdown correctly lands on the weight field,
   but by pointerup the browser resolves the SAME screen coordinate to
   the underlying product image instead - the popover's DOM node is
   gone. Critically: NO beforetoggle/toggle "closed" event was ever
   logged for it. That rules out every normal close path (light-dismiss,
   Escape, hidePopover) - all of those always fire those events.

   Root cause found by reading snippets/product-variants.liquid: the
   size-chart popup is rendered INSIDE Shopify's actual product
   `{% form %}` (used for variant/size selection), alongside the size
   swatches. Shopify's variant-change script listens broadly for
   input/change events anywhere in that form to re-render price and
   availability - and with no `name` attribute of their own to exclude
   them, the height/weight fields' keystrokes were very likely bubbling
   up and triggering that re-render, which replaces the whole block
   (including the popup) with a fresh, closed copy. That explains
   everything: no close event, because it was never "closed" - it was
   destroyed and replaced out from under the shopper.

   v6 (this version): the two fields now stop their own input/keydown/
   keyup/change/blur events from ever bubbling out of the field, so the
   form-level variant listener never sees them and never re-renders the
   block while the shopper is using the calculator. Enter-to-submit is
   now bound directly on each field (instead of via document, which
   would otherwise stop receiving the now-non-bubbling keydowns).

   Self-contained. To remove entirely: delete this file and its
   script_tag line at the bottom of snippets/size-chart-block.liquid.
------------------------------------------------------------------ */
(function () {
  'use strict';
  if (window.__mfSizeFinder) { return; }
  window.__mfSizeFinder = true;

  var SIZE_CHART = [
    { size: 'S',   hMin: 160, hMax: 173, wMin: 50,  wMax: 65,  length: 71, chest: 50 },
    { size: 'M',   hMin: 173, hMax: 179, wMin: 56,  wMax: 70,  length: 74, chest: 53 },
    { size: 'L',   hMin: 179, hMax: 182, wMin: 62,  wMax: 78,  length: 77, chest: 55 },
    { size: 'XL',  hMin: 183, hMax: 186, wMin: 68,  wMax: 85,  length: 80, chest: 58 },
    { size: 'XXL', hMin: 186, hMax: 190, wMin: 75,  wMax: 90,  length: 83, chest: 60 },
    { size: '3XL', hMin: 190, hMax: 195, wMin: 88,  wMax: 103, length: 86, chest: 62, estimated: true },
    { size: '4XL', hMin: 195, hMax: 205, wMin: 100, wMax: 118, length: 89, chest: 64, estimated: true }
  ];

  function closestEl(node, sel) {
    while (node && node.nodeType !== 1) { node = node.parentNode; }
    return node && node.closest ? node.closest(sel) : null;
  }

  function injectStyles() {
    if (document.getElementById('mf-size-css')) { return; }
    var css = [
      '.mf-size{margin:0 0 24px;padding:0 0 22px;border-bottom:1px solid var(--dotted-color, rgba(128,128,128,.28))}',
      '.mf-size__title{font-weight:700;margin:0 0 4px}',
      '.mf-size__intro{margin:0 0 14px;opacity:.75;font-size:.9em}',
      '.mf-size__row{display:flex;gap:14px;flex-wrap:wrap;margin-bottom:14px}',
      '.mf-size__field{flex:1;min-width:130px;display:block}',
      '.mf-size__field span{display:block;font-size:.78em;letter-spacing:.06em;text-transform:uppercase;opacity:.7;margin-bottom:6px}',
      '.mf-size__field input{width:100%;padding:11px 12px;font-size:16px;border:1px solid var(--dotted-color, rgba(128,128,128,.45));background:transparent;color:inherit;border-radius:0}',
      '.mf-size__go{cursor:pointer}',
      '.mf-size__result{margin-top:18px}',
      '.mf-size__label{font-size:.72em;letter-spacing:.14em;text-transform:uppercase;opacity:.65;margin:0 0 2px}',
      '.mf-size__value{font-size:2.4em;font-weight:800;line-height:1;margin:0 0 6px;color:var(--sale-color, inherit)}',
      '.mf-size__spec{margin:0 0 8px;font-size:.84em;opacity:.7}',
      '.mf-size__note{margin:0;font-size:.88em;opacity:.85}',
      '.mf-size__flag{margin:8px 0 0;font-size:.84em;font-weight:600;color:#b8860b}',
      '.mf-size__err{margin:0;font-size:.88em;color:#c0392b}',
      '.mf-size__disclaimer{margin:14px 0 0;font-size:.76em;opacity:.6}',
      '[id^="size-chart--"]{top:2vh!important;bottom:auto!important;margin:0 auto!important;max-height:90dvh;max-height:90vh;overflow-y:auto}'
    ].join('');
    var tag = document.createElement('style');
    tag.id = 'mf-size-css';
    tag.textContent = css;
    document.head.appendChild(tag);
  }

  function missBy(value, min, max) {
    if (value < min) { return min - value; }
    if (value > max) { return value - max; }
    return 0;
  }

  function recommend(heightCm, weightKg) {
    var best = null;
    for (var i = 0; i < SIZE_CHART.length; i++) {
      var row = SIZE_CHART[i];
      var mw = missBy(weightKg, row.wMin, row.wMax);
      var mh = missBy(heightCm, row.hMin, row.hMax);
      var centring = Math.abs(weightKg - (row.wMin + row.wMax) / 2) / 100;
      var score = mw + (mh * 0.5) + centring;
      if (!best || score < best.score) {
        best = { row: row, score: score, missWeight: mw, missHeight: mh };
      }
    }
    return best;
  }

  function runFinder(root) {
    var hEl = root.querySelector('[data-mf-size-height]');
    var wEl = root.querySelector('[data-mf-size-weight]');
    var out = root.querySelector('[data-mf-size-result]');
    if (!hEl || !wEl || !out) { return; }

    var h = parseFloat(hEl.value);
    var w = parseFloat(wEl.value);
    out.hidden = false;

    if (!h || !w || h < 120 || h > 220 || w < 25 || w > 200) {
      out.innerHTML = '<p class="mf-size__err">Please enter a height of 120-220 cm and a weight of 25-200 kg.</p>';
      return;
    }

    var best = recommend(h, w);
    var row = best.row;

    var note;
    if (best.missWeight === 0 && best.missHeight === 0) {
      note = 'You match this size on both height and weight in our size guide.';
    } else if (best.missWeight === 0) {
      note = 'Your weight sits in this size. Your height is just outside the listed range, so expect the fit to be slightly '
           + (h > row.hMax ? 'shorter' : 'longer') + ' on the body.';
    } else {
      note = 'This is the closest size to your measurements. If you prefer a roomier fit, take the next size up.';
    }

    out.innerHTML =
      '<p class="mf-size__label">Recommended size</p>' +
      '<p class="mf-size__value"></p>' +
      '<p class="mf-size__spec"></p>' +
      '<p class="mf-size__note"></p>';

    out.querySelector('.mf-size__value').textContent = row.size;
    out.querySelector('.mf-size__spec').textContent =
      'Chest ' + row.chest + ' cm - Length ' + row.length + ' cm';
    out.querySelector('.mf-size__note').textContent = note;

    if (row.estimated) {
      var flag = document.createElement('p');
      flag.className = 'mf-size__flag';
      flag.textContent = 'Note: ' + row.size + ' is not on our published size chart, so this is an estimate. Message us to confirm before ordering.';
      out.appendChild(flag);
    }
  }

  document.addEventListener('click', function (e) {
    var btn = closestEl(e.target, '[data-mf-size-go]');
    if (!btn) { return; }
    e.preventDefault();
    var root = btn.closest('[data-mf-size-finder]');
    if (!root) { return; }
    runFinder(root);
  });

  /* ---- The actual fix: the two fields live inside Shopify's product
     variant <form>. Stop every relevant event from bubbling past the
     field itself so the form's own variant-change listener (which
     re-renders the whole swatches/size-chart block on input/change) can
     never see them and never wipes the popup out mid-use. ---- */
  function wireField(field) {
    if (!field || field.__mfWired) { return; }
    field.__mfWired = true;
    ['input', 'change', 'keydown', 'keyup', 'keypress'].forEach(function (type) {
      field.addEventListener(type, function (e) {
        e.stopPropagation();
        if (type === 'keydown' && e.key === 'Enter') {
          e.preventDefault();
          var root = closestEl(field, '[data-mf-size-finder]');
          if (root) { runFinder(root); }
        }
      });
    });
  }

  function wireAllFields() {
    document.querySelectorAll('[data-mf-size-height], [data-mf-size-weight]').forEach(wireField);
  }

  /* ---- Reopen guard kept as a secondary safety net for the ordinary
     light-dismiss case (a real outside click/tap). Will not catch the
     "replaced out from under you" case above - the fix for that is the
     stopPropagation wiring, which addresses it at the source. ---- */
  var fieldsFocused = false;
  var lastFocusedField = null;

  document.addEventListener('focusin', function (e) {
    var f = closestEl(e.target, '[data-mf-size-height], [data-mf-size-weight]');
    if (f) { fieldsFocused = true; lastFocusedField = f; }
  });

  document.addEventListener('pointerdown', function (e) {
    var pop = closestEl(e.target, '[id^="size-chart--"]');
    if (!pop) { fieldsFocused = false; return; }
    if (closestEl(e.target, '[popovertargetaction="hide"]')) { fieldsFocused = false; }
  }, true);

  function guardPopovers() {
    document.querySelectorAll('[id^="size-chart--"]').forEach(function (pop) {
      if (pop.__mfGuarded) { return; }
      pop.__mfGuarded = true;
      pop.addEventListener('toggle', function (e) {
        if (e.newState !== 'closed' || !fieldsFocused) { return; }
        var field = lastFocusedField;
        var selStart, selEnd;
        if (field) { try { selStart = field.selectionStart; selEnd = field.selectionEnd; } catch (err) {} }
        if (typeof pop.showPopover === 'function') { pop.showPopover(); }
        if (field) {
          requestAnimationFrame(function () {
            field.focus();
            if (selStart != null) { try { field.setSelectionRange(selStart, selEnd); } catch (err) {} }
          });
        }
      });
    });
  }

  /* ---- Diagnostic overlay: add &mfdebug=1 to the URL to see it. ---- */
  function initDebugOverlay() {
    if (location.search.indexOf('mfdebug=1') === -1) { return; }
    var box = document.createElement('div');
    box.style.cssText = 'position:fixed;top:0;left:0;right:0;max-height:60vh;overflow-y:auto;' +
      'background:rgba(0,0,0,.94);color:#0f0;font:12px/1.5 monospace;padding:10px;' +
      'z-index:2147483647;white-space:pre-wrap;pointer-events:none;border-bottom:3px solid #0f0';
    var header = document.createElement('div');
    header.style.cssText = 'color:#fff;font-weight:bold;margin-bottom:6px;border-bottom:1px solid #444;padding-bottom:4px;position:sticky;top:-10px;background:rgba(0,0,0,.94)';
    header.textContent = 'MF DEBUG LOG (newest first) — screenshot this box the moment the popup closes';
    box.appendChild(header);
    document.documentElement.appendChild(box);

    var t0 = performance.now();
    var count = 0;
    function log(msg) {
      count++;
      var line = document.createElement('div');
      line.style.color = count % 2 ? '#0f0' : '#7fff7f';
      line.textContent = '+' + String(Math.round(performance.now() - t0)).padStart(6, ' ') + 'ms  ' + msg;
      box.insertBefore(line, header.nextSibling);
      var lines = box.querySelectorAll('div:not(:first-child)');
      if (lines.length > 60) { lines[lines.length - 1].remove(); }
    }

    function describe(t) {
      if (!t || !t.tagName) { return String(t); }
      var d = t.tagName;
      if (t.id) { d += '#' + t.id; }
      if (t.className && typeof t.className === 'string') { d += '.' + t.className.trim().split(/\s+/).join('.'); }
      if (t.hasAttribute) {
        ['data-mf-size-height', 'data-mf-size-weight', 'data-mf-size-go', 'popovertargetaction'].forEach(function (a) {
          if (t.hasAttribute(a)) { d += '[' + a + ']'; }
        });
      }
      return d;
    }

    ['pointerdown', 'pointerup', 'mousedown', 'mouseup', 'click'].forEach(function (type) {
      document.addEventListener(type, function (e) {
        log(type + ' -> ' + describe(e.target) + '  @(' + Math.round(e.clientX) + ',' + Math.round(e.clientY) + ')');
      }, true);
    });

    document.addEventListener('keydown', function (e) {
      log('keydown key="' + e.key + '" -> ' + describe(e.target));
    }, true);

    document.addEventListener('focusin', function (e) {
      log('focusin -> ' + describe(e.target));
    }, true);
    document.addEventListener('focusout', function (e) {
      log('focusout -> ' + describe(e.target));
    }, true);

    document.addEventListener('input', function (e) {
      log('input -> ' + describe(e.target) + ' value="' + (e.target && e.target.value) + '"');
    }, true);

    function hookToggles() {
      document.querySelectorAll('[id^="size-chart--"]').forEach(function (pop) {
        if (pop.__mfDebugHooked) { return; }
        pop.__mfDebugHooked = true;
        pop.addEventListener('beforetoggle', function (e) {
          log('*** BEFORETOGGLE oldState=' + e.oldState + ' newState=' + e.newState + ' ***');
        });
        pop.addEventListener('toggle', function (e) {
          log('*** TOGGLE oldState=' + e.oldState + ' newState=' + e.newState + ' (fieldsFocused=' + fieldsFocused + ') ***');
        });
      });
    }
    hookToggles();
    new MutationObserver(hookToggles).observe(document.body, { childList: true, subtree: true });

    log('debug overlay ready');
  }

  function boot() {
    injectStyles();
    wireAllFields();
    guardPopovers();
    initDebugOverlay();
    new MutationObserver(function () { wireAllFields(); guardPopovers(); }).observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();